import { jsxs, jsx } from "react/jsx-runtime";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
const DealerInfoServices = ({
  label,
  value,
  className,
  mode = "column",
  showIcon = true
}) => {
  const renderIcon = (showIcon2, iconType) => {
    if (!showIcon2) {
      return /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark", className: classnames("perxis-auto-dealer-info-services__service-icon"), children: "—" });
    }
    if (!iconType) {
      return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-services__service-icon-empty") });
    }
    return /* @__PURE__ */ jsx(Icon, { name: iconType, className: classnames("perxis-auto-dealer-info-services__service-icon") });
  };
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-services", className), children: [
    /* @__PURE__ */ jsxs(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-dealer-info-services__label"), children: [
      label,
      ":"
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classnames([
          "perxis-auto-dealer-info-services__container",
          `perxis-auto-dealer-info-services__container--${mode}`
        ]),
        children: value.map((service) => /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-services__service"), children: [
          renderIcon(showIcon, service.icon),
          /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark", className: classnames("perxis-auto-dealer-info-services__value"), children: service.label })
        ] }, service.id))
      }
    )
  ] });
};
export {
  DealerInfoServices as default
};
//# sourceMappingURL=DealerInfoServices.js.map
